import { Suspense } from 'react';
import { Box } from '@wishket/design-system';
import { ErrorBoundary } from 'react-error-boundary';

import { getTrendingContents } from './models';

import {
  TrendingContents as TrendingContentsFeature,
  TrendingContentsHeader,
} from '@/features/Landing';
import { Skeleton } from '@/shared/Components';

const TrendingContents = () => {
  const trendingContentsPromise = getTrendingContents();

  return (
    <ErrorBoundary
      fallback={
        <Skeleton className="h-[494px] tablet:h-[282px] desktop:h-[576px]" />
      }
    >
      <Suspense
        fallback={
          <Skeleton className="h-[494px] tablet:h-[282px] desktop:h-[576px]" />
        }
      >
        <Box className="flex flex-col gap-6 rounded-3xl border border-w-gray-100 px-5 py-6 desktop:gap-8 desktop:p-8 desktop:pb-10">
          <TrendingContentsHeader />
          <TrendingContentsFeature contentsPromise={trendingContentsPromise} />
        </Box>
      </Suspense>
    </ErrorBoundary>
  );
};

export default TrendingContents;
